import { useEffect, useRef } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * Desktop keyboard UX for modal input fields: auto-focus + select all, Enter to confirm.
 * Skipped on touch/coarse pointer devices to avoid OS virtual keyboard.
 */
export const useDesktopModalInput = ({
  open,
  onConfirm,
  enabled = true,
  focusKey,
  selectOnFocus = true,
}) => {
  const inputRef = useRef(null);
  const isDesktopKeyboard = useMediaQuery('(pointer: fine) and (min-width: 769px)');

  useEffect(() => {
    if (!open || !enabled || !isDesktopKeyboard) return undefined;
    const id = requestAnimationFrame(() => {
      const el = inputRef.current;
      if (!el) return;
      el.focus();
      if (selectOnFocus) {
        el.select();
      }
    });
    return () => cancelAnimationFrame(id);
  }, [open, enabled, isDesktopKeyboard, focusKey, selectOnFocus]);

  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onConfirm?.();
    }
  };

  return { inputRef, handleInputKeyDown, isDesktopKeyboard };
};
